module.exports = __webpack_public_path__ + "static/img/so6_3.07b53ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/so6_3.jpg
// module id = wvZU
// module chunks = 11